// import React, { useRef, useEffect, useState } from "react";
// import {
//   MDBContainer,
//   MDBRow,
//   MDBCol,
//   MDBCard,
//   MDBCardBody,
//   MDBCardTitle,
//   MDBCardText,
//   MDBBtn,
//   MDBIcon,
// } from "mdb-react-ui-kit";

// import { useNavigate, Link } from "react-router-dom";
// import BarChart from "../components/BarChart";
// import PieChart from "../components/PieChart";
// import MisTable from "../components/MisTable";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import API_BASE_URL from "../utilities/apiConfig";

// import totalregicon from "../assets/images/totalregicon.png";
// import mostactiveicon from "../assets/images/mostactiveicon.png";
// import mostinactive from "../assets/images/mostinactive.png";
// import Dashboardicon from "../assets/images/Dashboardicon.png";
// import baricon from "../assets/images/baricon.png";
// import newreg from "../assets/images/newreg.png";
// import proficon from "../assets/images/proficon.png";
// import MisReporting from "../components/apiComponents/MisReporting";
// import axios from "axios";
// import filterAndReduceVoucherAmountMonthly from "../utilities/filterAndReduceVoucherAmountMonthly";
// import filterAndReduceVoucherAmountYearly from "../utilities/filterAndReduceVoucherAmountYearly";
// import filterAndReduceVoucherAmountByMonthlyAndVoucherType from "../utilities/filterAndReduceVoucherAmountByMonthlyAndVoucherType";
// import filterAndCountByVoucherType from "../utilities/filterAndCountByVoucherType";
// import findUniqueCountOfUttrakhandBarId from "../utilities/findUniqueCountOfUttrakhandBarId";
// import Loader from "../components/Loader";
// import axiosInstance from "../utilities/apiConfig";

// // Register the components

// const Dashboard = () => {
//   const [selectedDate, setSelectedDate] = useState(null);
//   const registrationRequestText = "New Registration Request";
//   const [showTable, setShowTable] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [soldVoucherDetailsList, setSoldVoucherDetailsList] = useState([]);
//   const [missingVoucherDetailsList, setMissingVoucherDetailsList] = useState(
//     []
//   );
//   const [activeMemberVoucherDetailsList, setActiveMemberVoucherDetailsList] =
//     useState([]);
//   const [pendingMembershipDetails, setPendingMembershipDetails] = useState([]);
//   const [acceptedMembershipDetails, setAcceptedMembershipDetails] = useState(
//     []
//   );
//   const [newVerifiedMembershipDetails, setNewVerifiedMembershipDetails] =
//     useState([]);
//   const [inactiveMembersDetailsList, setInactiveMembersDetailsList] = useState(
//     []
//   );
//   const [totalCountOfTablesData, setTotalCountOfTablesData] = useState("");
//   const history = useNavigate();
//   // Get the current date
//   const currentDate = new Date();
//   // Get the current month (zero-based index, so add 1 for the actual month number)
//   const currentMonth = currentDate.getMonth() + 1;
//   // Calculate the previous month
//   // Adjusting for January (month 0) to December (month 11) rollover
//   const previousMonth = currentMonth === 1 ? 12 : currentMonth - 1;
//   const currentYear = currentDate.getFullYear();
//   const MonthlySales = [];
//   const monthsInYear = 12; // Assuming you want sales for all 12 months of the year

//   for (let month = 1; month <= monthsInYear; month++) {
//     debugger;
//     const reducedAmount = filterAndReduceVoucherAmountMonthly(
//       soldVoucherDetailsList,
//       month
//     );
//     MonthlySales.push(reducedAmount);
//   }

//   console.log(MonthlySales);

//   const voucherNames = [
//     "Coupon",
//     "Memo",
//     "Vakalatnama",
//     "Sale deed/Gift deed",
//     "Marriage Coupon",
//     "Will/Attorney/Lease /Agreement",
//     "Challan Coupon",
//   ];

//   const MonthlyMissingVoucherCounts = [];

//   for (let voucherName of voucherNames) {
//     const countByVoucherType = filterAndCountByVoucherType(
//       missingVoucherDetailsList,
//       currentYear,
//       voucherName
//     );
//     MonthlyMissingVoucherCounts.push(countByVoucherType);
//   }

//   console.log("missing vouchers counts", MonthlyMissingVoucherCounts);

//   const handleGetSoldVoucherDetailsByBarAssociationId = async () => {
//     try {
//       setLoading(true);
//       const response = await axiosInstance.get(
//         `/Dashboard/get_voucher_details_by_provided_parameters?barAssociationCode=1`
//       );

//       console.log(response.data);
//       if (response.data.response.statusCode === 200) {
//         setSoldVoucherDetailsList(response.data.voucherDetailsList);
//       } else {
//         setSoldVoucherDetailsList([]);
//       }
//     } catch (error) {
//       console.log(error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleGetMissingVoucherDetailsByBarAssociationId = async () => {
//     try {
//       setLoading(true);
//       const response = await axiosInstance.get(
//         `/Dashboard/get_missing_voucher_details`
//       );

//       console.log(response.data);
//       if (response.data.response.statusCode === 200) {
//         setMissingVoucherDetailsList(response.data.voucherDetailsList);
//       } else {
//         setMissingVoucherDetailsList([]);
//       }
//     } catch (error) {
//       console.log(error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleGetActiveMembersVoucherDetailsByBarAssociationId = async () => {
//     try {
//       setLoading(true);
//       const response = await axiosInstance.get(
//         `/Dashboard/get_most_active_members_voucher_purchase`
//       );

//       console.log("active members data", response.data);
//       if (response.data.response.statusCode === 200) {
//         setActiveMemberVoucherDetailsList(response.data.activeMembersList);
//       } else {
//         setActiveMemberVoucherDetailsList([]);
//       }
//     } catch (error) {
//       console.log(error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleGetInactiveMemberFromTwoMonths = async () => {
//     try {
//       setLoading(true);
//       const response = await axiosInstance.get(
//         `/Dashboard/get_inactive_members_from_last_two_month`
//       );

//       console.log("inactive request data", response.data);
//       if (response.data.response.statusCode === 200) {
//         setInactiveMembersDetailsList(response.data.inactiveMembers);
//       } else {
//         setInactiveMembersDetailsList([]);
//       }
//     } catch (error) {
//       console.log(error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleGetPendingRegistrationRequest = async () => {
//     try {
//       setLoading(true);
//       const response = await axiosInstance.get(
//         `/Registration/pending_registration_requests`
//       );

//       console.log("pending request data", response.data);
//       if (response.data.response.statusCode === 200) {
//         setPendingMembershipDetails(response.data.pendingRequests);
//       } else {
//         setPendingMembershipDetails([]);
//       }
//     } catch (error) {
//       console.log(error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleGetNewVerifiedAdvocateDetails = async () => {
//     try {
//       setLoading(true);
//       const response = await axiosInstance.get(
//         `/Dashboard/get_latest_verification_advocate_list`
//       );

//       console.log("new verified advocate data", response.data);
//       if (response.data.response.statusCode === 200) {
//         setNewVerifiedMembershipDetails(response.data.newVerificationList);
//       } else {
//         setNewVerifiedMembershipDetails([]);
//       }
//     } catch (error) {
//       console.log(error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleGetDashboardTableDetailsCount = async () => {
//     //debugger;
//     try {
//       const response = await axiosInstance.get(
//         `/LoginFees/get_tables_data_count`
//       );
//       console.log(response.data);
//       if (response.data.statusCode === 200) {
//         setTotalCountOfTablesData(response.data.listToTableCounts);
//       } else {
//         setTotalCountOfTablesData("");
//       }
//     } catch (error) {
//       console.log("total count error fetching", error);
//     }
//   };

//   const navigate = useNavigate();

//   useEffect(() => {
//     // handleGetAcceptedRegistrationRequest();
//     // handleGetNewVerifiedAdvocateDetails();
//     handleGetSoldVoucherDetailsByBarAssociationId();
//     handleGetMissingVoucherDetailsByBarAssociationId();
//     handleGetActiveMembersVoucherDetailsByBarAssociationId();
//     handleGetInactiveMemberFromTwoMonths();
//     // handleGetPendingRegistrationRequest();
//     handleGetDashboardTableDetailsCount();

//     // console.log('total counts of table data', totalCountOfTablesData);
//   }, []);

//   useEffect(() => {
//     console.log("total counts of table data", totalCountOfTablesData);
//   }, [totalCountOfTablesData]);

//   console.log(
//     "Reduced voucher amount for current month",
//     currentMonth,
//     "and year",
//     ":",
//     filterAndReduceVoucherAmountMonthly(soldVoucherDetailsList, currentMonth)
//   );
//   console.log(
//     "Reduced voucher amount for current year",
//     ":",
//     filterAndReduceVoucherAmountYearly(soldVoucherDetailsList, currentYear)
//   );

//   const openPdfFromResponse = (data) => {
//     // Create a Blob from the response data
//     const file = new Blob([data], { type: "application/pdf" });

//     // Create a temporary URL for the Blob
//     const fileURL = URL.createObjectURL(file);

//     // Open the PDF in a new tab
//     window.open(fileURL, "_blank");
//   };

//   const handleTentativeVotingList = async () => {
//     try {
//       setLoading(true);
//       // Note: Endpoint path matches the Controller Route + Method Route
//       // Route("api/[controller]") -> /api/Dashboard/TentativeVotingList
//       const response = await axiosInstance.get(
//         `/Dashboard/TentativeVotingList`,
//         { responseType: "blob" } // CRITICAL: Tells axios to handle response as a file
//       );

//       openPdfFromResponse(response.data);
//     } catch (error) {
//       console.error("Error fetching Tentative List:", error);
//       alert(
//         "Could not open the voting list. Please ensure the file exists on the server."
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleDefaulterList = async () => {
//     try {
//       setLoading(true);

//       // TODO: set this from your FY dropdown selection
//       const financialYear = selectedFinancialYear; // e.g. "2024-2025"

//       if (!financialYear) {
//         alert("Please select Financial Year.");
//         return;
//       }

//       const response = await axiosInstance.get(`/Dashboard/DefaulterList`, {
//         params: { financialYear },
//       });

//       // response.data => { response: {...}, defaulters: [...] }
//       const { response: apiRes, defaulters } = response.data || {};

//       if (apiRes?.statusCode !== 200) {
//         alert(apiRes?.status || "Failed to fetch defaulter list.");
//         return;
//       }

//       // Now you can show this list in UI (table / modal)
//       setDefaulterList(defaulters || []);
//       setShowDefaulterModal(true); // if you use a modal
//     } catch (error) {
//       console.error("Error fetching Defaulter List:", error);
//       alert("Could not fetch the defaulter list. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       {" "}
//       {loading && <Loader />}
//       <div className="pb-4">
//         <MDBContainer fluid>
//           <MDBRow className="my-3">
//             <MDBCol md="8" className="d-flex align-items-center">
//               <img
//                 src={Dashboardicon}
//                 alt="Dashboard Icon"
//                 className="me-2"
//                 style={{ width: "42px" }}
//               />
//               <h4 className="m-0" style={{ fontWeight: "bold" }}>
//                 Dashboard
//               </h4>
//             </MDBCol>
//             <MDBCol
//               md="12"
//               className="d-flex justify-content-end align-items-center"
//             >
//               <a href="/UserCreation">
//                 <MDBBtn color="primary" className="text-nowrap">
//                   Create User
//                 </MDBBtn>
//               </a>
//               &nbsp;
//               <a href="/FeesAndVoucherDetails">
//                 <MDBBtn color="success" className="text-nowrap">
//                   Data Table
//                 </MDBBtn>
//               </a>
//               &nbsp;
//               <a href="/GenrateVotingList">
//                 <MDBBtn color="warning" className="text-nowrap">
//                   Genrate Voting list
//                 </MDBBtn>
//               </a>
//               &nbsp;
//               <a href="/DeleteAdvocateDetails">
//                 <MDBBtn color="danger" className="text-nowrap">
//                   Delete Advocate Details
//                 </MDBBtn>
//               </a>
//               &nbsp;
//               <MDBBtn
//                 color="warning"
//                 className="text-nowrap"
//                 onClick={handleTentativeVotingList}
//                 disabled={loading} // Optional: Disable while fetching
//               >
//                 Tentative Voting list
//               </MDBBtn>
//               &nbsp;
//               <MDBBtn
//                 color="warning"
//                 className="text-nowrap"
//                 onClick={handleDefaulterList}
//                 disabled={loading}
//               >
//                 Defaulter list
//               </MDBBtn>
//             </MDBCol>
//           </MDBRow>

//           <MDBCard className="mb-2">
//             <MDBCardBody>
//               <MDBRow className="d-flex justify-content-between mb-1">
//                 <MDBCol className="flex-grow-1 mx-2 p-1">
//                   <MDBCardTitle style={{ fontWeight: "bold" }}>
//                     Members Analytics
//                   </MDBCardTitle>
//                   <MDBCardText className="text-small">
//                     Data Shows As Per Member Activity
//                   </MDBCardText>
//                 </MDBCol>
//                 <MDBCol className="flex-grow-1 mx-2 p-1">
//                   <MDBRow className="align-items-center">
//                     <MDBCol size="auto">
//                       <img
//                         src={totalregicon}
//                         alt="Check Circle Icon"
//                         className="me-2"
//                         style={{ width: "48px" }}
//                       />
//                     </MDBCol>
//                     <MDBCol>
//                       <MDBCardText>
//                         <h1>
//                           {" "}
//                           {totalCountOfTablesData[3]?.tableNoOfRowsCounts}
//                         </h1>
//                         <p className="text-small">Total Registered Members</p>
//                       </MDBCardText>
//                     </MDBCol>
//                   </MDBRow>
//                   <MDBBtn
//                     color="link"
//                     onClick={() =>
//                       navigate(`/TotalRegMembers`, {
//                         state: { RegistredMembers: acceptedMembershipDetails },
//                       })
//                     }
//                     style={{ textDecoration: "none" }}
//                     rippleColor="dark"
//                   >
//                     View all
//                   </MDBBtn>
//                 </MDBCol>

//                 <MDBCol className="flex-grow-1 mx-2 p-1">
//                   <MDBRow className="align-items-center">
//                     <MDBCol size="auto">
//                       <img
//                         src={newreg}
//                         alt="Check Circle Icon"
//                         className="me-2"
//                         style={{ width: "48px" }}
//                       />
//                     </MDBCol>
//                     <MDBCol>
//                       <MDBCardText>
//                         <h1>
//                           {totalCountOfTablesData[0]?.tableNoOfRowsCounts}
//                         </h1>
//                         <p className="text-small">New Registration Request</p>
//                       </MDBCardText>
//                     </MDBCol>
//                   </MDBRow>
//                   <MDBBtn
//                     color="link"
//                     onClick={() =>
//                       navigate(`/NewRegReq`, {
//                         state: {
//                           NewRegistrationRequest: pendingMembershipDetails,
//                         },
//                       })
//                     }
//                     style={{ textDecoration: "none" }}
//                     rippleColor="dark"
//                   >
//                     View all
//                   </MDBBtn>
//                 </MDBCol>

//                 <MDBCol className="flex-grow-1 mx-2 p-1">
//                   <MDBRow className="align-items-center">
//                     <MDBCol size="auto">
//                       <img
//                         src={mostinactive}
//                         alt="Check Circle Icon"
//                         className="me-2"
//                         style={{ width: "48px" }}
//                       />
//                     </MDBCol>
//                     <MDBCol>
//                       <MDBCardText>
//                         <h1>{inactiveMembersDetailsList?.length}</h1>
//                         <p className="text-small">Most Inactive Members</p>
//                       </MDBCardText>
//                     </MDBCol>
//                   </MDBRow>
//                   <MDBBtn
//                     color="link"
//                     onClick={() =>
//                       navigate(`/Inactive`, {
//                         state: {
//                           InactiveMembersData: inactiveMembersDetailsList,
//                         },
//                       })
//                     }
//                     style={{ textDecoration: "none" }}
//                     rippleColor="dark"
//                   >
//                     View all
//                   </MDBBtn>
//                 </MDBCol>

//                 <MDBCol className="flex-grow-1 mx-2 p-1">
//                   <MDBRow className="align-items-center">
//                     <MDBCol size="auto">
//                       <img
//                         src={mostactiveicon}
//                         alt="Check Circle Icon"
//                         className="me-2"
//                         style={{ width: "48px" }}
//                       />
//                     </MDBCol>
//                     <MDBCol>
//                       <MDBCardText>
//                         <h1>
//                           {findUniqueCountOfUttrakhandBarId(
//                             activeMemberVoucherDetailsList
//                           )}
//                         </h1>
//                         <p className="text-small">Most Active Members</p>
//                       </MDBCardText>
//                     </MDBCol>
//                   </MDBRow>
//                   <MDBBtn
//                     color="link"
//                     onClick={() =>
//                       navigate(`/Active`, {
//                         state: {
//                           ActiveMembersData: activeMemberVoucherDetailsList,
//                         },
//                       })
//                     }
//                     style={{ textDecoration: "none" }}
//                     rippleColor="dark"
//                   >
//                     View all
//                   </MDBBtn>
//                 </MDBCol>
//               </MDBRow>
//             </MDBCardBody>
//           </MDBCard>

//           <MDBRow>
//             <MDBCol lg="4">
//               <MDBCol className="mb-4">
//                 <MDBCard className="">
//                   <MDBCardBody className="d-flex flex-column">
//                     <MDBRow className="d-flex justify-content-between mb-3">
//                       <MDBCol
//                         md="8"
//                         className="d-flex flex-column align-items-start"
//                       >
//                         <MDBCardTitle style={{ fontWeight: "bold" }}>
//                           Registration Analytics
//                         </MDBCardTitle>
//                         <MDBCardText className="text-small">
//                           Data Shows Total Registration and New Request
//                         </MDBCardText>
//                       </MDBCol>
//                       <MDBCol
//                         md="4"
//                         className="d-flex flex-column align-items-end"
//                       >
//                         {/* <DatePicker
//                         selected={selectedDate}
//                         onChange={(date) => setSelectedDate(date)}
//                         placeholderText="Select Date"
//                         className="form-control"
//                       /> */}
//                       </MDBCol>
//                     </MDBRow>
//                     <MDBRow className="d-flex justify-content-between mt-4">
//                       <MDBCol
//                         md="6"
//                         className="d-flex flex-column align-items-start"
//                       >
//                         <MDBCardText>
//                           <h2>
//                             {" "}
//                             {totalCountOfTablesData[3]?.tableNoOfRowsCounts}
//                           </h2>
//                           <p className="text-small">Total Registration</p>
//                         </MDBCardText>
//                       </MDBCol>
//                       <MDBCol
//                         md="6"
//                         className="d-flex flex-column align-items-end"
//                       >
//                         <MDBCardText>
//                           <h2>
//                             {" "}
//                             {totalCountOfTablesData[1]?.tableNoOfRowsCounts}
//                           </h2>
//                           <p
//                             onClick={() => navigate(`/RejectedRequestDetails`)}
//                             style={{
//                               textDecoration: "none",
//                               cursor: "pointer",
//                             }}
//                             rippleColor="dark"
//                             className="text-small"
//                           >
//                             Rejected Registration Request
//                           </p>
//                         </MDBCardText>
//                       </MDBCol>
//                     </MDBRow>
//                   </MDBCardBody>
//                 </MDBCard>
//               </MDBCol>

//               <MDBCol className="mb-4">
//                 <MDBCard className="h-100">
//                   <MDBCardBody className="d-flex flex-column">
//                     <MDBRow className="d-flex justify-between mb-3">
//                       <MDBCol
//                         md="10"
//                         className="d-flex flex-column align-items-start"
//                       >
//                         <MDBCardTitle style={{ fontWeight: "bold" }}>
//                           Verification Analytics
//                         </MDBCardTitle>
//                         <MDBCardText className="text-small">
//                           Data Shows Total Verification and New Verification
//                         </MDBCardText>
//                       </MDBCol>
//                     </MDBRow>
//                     <MDBRow className="d-flex justify-content-between mt-4">
//                       <MDBCol
//                         md="6"
//                         className="d-flex flex-column align-items-start"
//                       >
//                         <MDBCardText>
//                           <h2>
//                             {" "}
//                             {totalCountOfTablesData[3]?.tableNoOfRowsCounts}
//                           </h2>
//                           <p color="link" className="text-small">
//                             Total Registered Members
//                           </p>
//                         </MDBCardText>
//                       </MDBCol>
//                       <MDBCol
//                         md="6"
//                         className="d-flex flex-column align-items-end"
//                       >
//                         <MDBCardText>
//                           <h2>
//                             {" "}
//                             {totalCountOfTablesData[2]?.tableNoOfRowsCounts}
//                           </h2>
//                           <p
//                             color="link"
//                             onClick={() =>
//                               navigate(`/LatestVerifiactionDetailsPage`)
//                             }
//                             style={{
//                               textDecoration: "none",
//                               cursor: "pointer",
//                             }}
//                             rippleColor="dark"
//                           >
//                             New Verification
//                           </p>
//                         </MDBCardText>
//                       </MDBCol>
//                     </MDBRow>
//                   </MDBCardBody>
//                 </MDBCard>
//               </MDBCol>
//             </MDBCol>

//             <MDBCol lg="4" className="mb-4">
//               <MDBCard className="h-100">
//                 <MDBCardBody className="d-flex flex-column">
//                   <MDBRow className="d-flex justify-content-between mb-3">
//                     <MDBCol
//                       md="6"
//                       className="d-flex flex-column align-items-start"
//                     >
//                       <MDBCardTitle style={{ fontWeight: "bold" }}>
//                         Total Revenue
//                       </MDBCardTitle>
//                       <MDBCardText className="text-small">
//                         Total Revenue in all Sections per Month
//                       </MDBCardText>
//                     </MDBCol>
//                     <MDBCol
//                       md="6"
//                       className="d-flex flex-column align-items-end"
//                     >
//                       <MDBCardText>
//                         <h4>
//                           ₹{" "}
//                           {filterAndReduceVoucherAmountYearly(
//                             soldVoucherDetailsList,
//                             currentYear
//                           )}
//                         </h4>
//                         <p className="text-small">Year {currentYear}</p>
//                       </MDBCardText>
//                     </MDBCol>
//                   </MDBRow>
//                   <MDBRow className="d-flex justify-content-center flex-grow-1">
//                     <div style={{ width: "100%", height: "auto" }}>
//                       {/* bar char details for the montly data show on label */}

//                       <BarChart
//                         MonthlySalesArray={MonthlySales}
//                         SoldVoucherList={soldVoucherDetailsList}
//                       />
//                     </div>
//                   </MDBRow>
//                   <MDBRow className="d-flex">
//                     <MDBCol
//                       md="6"
//                       className="d-flex flex-column align-items-start"
//                     >
//                       <MDBCardText>
//                         <h4>
//                           ₹{" "}
//                           {filterAndReduceVoucherAmountMonthly(
//                             soldVoucherDetailsList,
//                             previousMonth,
//                             currentYear
//                           )}
//                         </h4>
//                         <p className="text-small">
//                           Revenue Generated in Last Month
//                         </p>
//                       </MDBCardText>
//                     </MDBCol>
//                     <MDBCol
//                       md="6"
//                       className="d-flex flex-column align-items-end"
//                     >
//                       <MDBCardText>
//                         <h4>
//                           ₹{" "}
//                           {filterAndReduceVoucherAmountMonthly(
//                             soldVoucherDetailsList,
//                             currentMonth,
//                             currentYear
//                           )}
//                         </h4>
//                         <p className="text-small">
//                           Revenue Generated in Current Month
//                         </p>
//                       </MDBCardText>
//                     </MDBCol>
//                   </MDBRow>
//                 </MDBCardBody>
//               </MDBCard>
//             </MDBCol>

//             <MDBCol lg="4" className="mb-4">
//               <MDBCard className="h-100">
//                 <MDBCardBody className="d-flex flex-column">
//                   <MDBRow className="d-flex justify-content-between mb-3">
//                     <MDBCol
//                       md="8"
//                       className="d-flex flex-column align-items-start"
//                     >
//                       <MDBCardTitle style={{ fontWeight: "bold" }}>
//                         Missing Data Analytics
//                       </MDBCardTitle>
//                       <MDBCardText className="text-small">
//                         Missing Coupon Data In All Sections
//                       </MDBCardText>
//                     </MDBCol>
//                   </MDBRow>
//                   <MDBRow className="d-flex justify-content-center flex-grow-1">
//                     <MDBCol
//                       md="12"
//                       className="d-flex flex-column align-items-center mt-1"
//                     >
//                       {MonthlyMissingVoucherCounts.length > 0 && (
//                         <PieChart voucherCounts={MonthlyMissingVoucherCounts} />
//                       )}
//                     </MDBCol>
//                   </MDBRow>
//                 </MDBCardBody>
//               </MDBCard>
//             </MDBCol>
//           </MDBRow>

//           <MisReporting />
//         </MDBContainer>
//       </div>
//     </>
//   );
// };

// export default Dashboard;

import React, { useRef, useEffect, useState } from "react";
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBBtn,
  MDBIcon,
} from "mdb-react-ui-kit";

import { useNavigate, Link } from "react-router-dom";
import BarChart from "../components/BarChart";
import PieChart from "../components/PieChart";
import MisTable from "../components/MisTable";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import API_BASE_URL from "../utilities/apiConfig";

import totalregicon from "../assets/images/totalregicon.png";
import mostactiveicon from "../assets/images/mostactiveicon.png";
import mostinactive from "../assets/images/mostinactive.png";
import Dashboardicon from "../assets/images/Dashboardicon.png";
import baricon from "../assets/images/baricon.png";
import newreg from "../assets/images/newreg.png";
import proficon from "../assets/images/proficon.png";
import MisReporting from "../components/apiComponents/MisReporting";
import axios from "axios";
import filterAndReduceVoucherAmountMonthly from "../utilities/filterAndReduceVoucherAmountMonthly";
import filterAndReduceVoucherAmountYearly from "../utilities/filterAndReduceVoucherAmountYearly";
import filterAndReduceVoucherAmountByMonthlyAndVoucherType from "../utilities/filterAndReduceVoucherAmountByMonthlyAndVoucherType";
import filterAndCountByVoucherType from "../utilities/filterAndCountByVoucherType";
import findUniqueCountOfUttrakhandBarId from "../utilities/findUniqueCountOfUttrakhandBarId";
import Loader from "../components/Loader";
import axiosInstance from "../utilities/apiConfig";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

// Register the components

const Dashboard = () => {
  const [selectedDate, setSelectedDate] = useState(null);
  const registrationRequestText = "New Registration Request";
  const [showTable, setShowTable] = useState(false);
  const [loading, setLoading] = useState(false);
  const [soldVoucherDetailsList, setSoldVoucherDetailsList] = useState([]);
  const [missingVoucherDetailsList, setMissingVoucherDetailsList] = useState(
    []
  );
  const [activeMemberVoucherDetailsList, setActiveMemberVoucherDetailsList] =
    useState([]);
  const [pendingMembershipDetails, setPendingMembershipDetails] = useState([]);
  const [acceptedMembershipDetails, setAcceptedMembershipDetails] = useState(
    []
  );
  const [newVerifiedMembershipDetails, setNewVerifiedMembershipDetails] =
    useState([]);
  const [inactiveMembersDetailsList, setInactiveMembersDetailsList] = useState(
    []
  );
  const [totalCountOfTablesData, setTotalCountOfTablesData] = useState("");

  // ✅ ONLY ADDED for FY dropdown + defaulter list
  const [financialYearList, setFinancialYearList] = useState([]); // dropdown options
  const [selectedFinancialYear, setSelectedFinancialYear] = useState(""); // dropdown selected
  const [defaulterList, setDefaulterList] = useState([]); // data for defaulters (your handler already uses it)
  const [showDefaulterModal, setShowDefaulterModal] = useState(false); // your handler already uses it

  const history = useNavigate();
  // Get the current date
  const currentDate = new Date();
  // Get the current month (zero-based index, so add 1 for the actual month number)
  const currentMonth = currentDate.getMonth() + 1;
  // Calculate the previous month
  // Adjusting for January (month 0) to December (month 11) rollover
  const previousMonth = currentMonth === 1 ? 12 : currentMonth - 1;
  const currentYear = currentDate.getFullYear();
  const MonthlySales = [];
  const monthsInYear = 12; // Assuming you want sales for all 12 months of the year

  for (let month = 1; month <= monthsInYear; month++) {
    const reducedAmount = filterAndReduceVoucherAmountMonthly(
      soldVoucherDetailsList,
      month
    );
    MonthlySales.push(reducedAmount);
  }

  console.log(MonthlySales);

  const voucherNames = [
    "Coupon",
    "Memo",
    "Vakalatnama",
    "Sale deed/Gift deed",
    "Marriage Coupon",
    "Will/Attorney/Lease /Agreement",
    "Challan Coupon",
  ];

  const MonthlyMissingVoucherCounts = [];

  for (let voucherName of voucherNames) {
    const countByVoucherType = filterAndCountByVoucherType(
      missingVoucherDetailsList,
      currentYear,
      voucherName
    );
    MonthlyMissingVoucherCounts.push(countByVoucherType);
  }

  console.log("missing vouchers counts", MonthlyMissingVoucherCounts);

  const handleGetSoldVoucherDetailsByBarAssociationId = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `/Dashboard/get_voucher_details_by_provided_parameters?barAssociationCode=1`
      );

      console.log(response.data);
      if (response.data.response.statusCode === 200) {
        setSoldVoucherDetailsList(response.data.voucherDetailsList);
      } else {
        setSoldVoucherDetailsList([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleGetMissingVoucherDetailsByBarAssociationId = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `/Dashboard/get_missing_voucher_details`
      );

      console.log(response.data);
      if (response.data.response.statusCode === 200) {
        setMissingVoucherDetailsList(response.data.voucherDetailsList);
      } else {
        setMissingVoucherDetailsList([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleGetActiveMembersVoucherDetailsByBarAssociationId = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `/Dashboard/get_most_active_members_voucher_purchase`
      );

      console.log("active members data", response.data);
      if (response.data.response.statusCode === 200) {
        setActiveMemberVoucherDetailsList(response.data.activeMembersList);
      } else {
        setActiveMemberVoucherDetailsList([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleGetInactiveMemberFromTwoMonths = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `/Dashboard/get_inactive_members_from_last_two_month`
      );

      console.log("inactive request data", response.data);
      if (response.data.response.statusCode === 200) {
        setInactiveMembersDetailsList(response.data.inactiveMembers);
      } else {
        setInactiveMembersDetailsList([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleGetPendingRegistrationRequest = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `/Registration/pending_registration_requests`
      );

      console.log("pending request data", response.data);
      if (response.data.response.statusCode === 200) {
        setPendingMembershipDetails(response.data.pendingRequests);
      } else {
        setPendingMembershipDetails([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleGetNewVerifiedAdvocateDetails = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `/Dashboard/get_latest_verification_advocate_list`
      );

      console.log("new verified advocate data", response.data);
      if (response.data.response.statusCode === 200) {
        setNewVerifiedMembershipDetails(response.data.newVerificationList);
      } else {
        setNewVerifiedMembershipDetails([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleGetDashboardTableDetailsCount = async () => {
    try {
      const response = await axiosInstance.get(
        `/LoginFees/get_tables_data_count`
      );
      console.log(response.data);
      if (response.data.statusCode === 200) {
        setTotalCountOfTablesData(response.data.listToTableCounts);
      } else {
        setTotalCountOfTablesData("");
      }
    } catch (error) {
      console.log("total count error fetching", error);
    }
  };

  // ✅ ONLY ADDED: Get FY dropdown list from the API we created
  const handleGetFinancialYearDropdown = async () => {
    try {
      // do not block whole dashboard with loader for dropdown;
      // but keeping your existing pattern as-is:
      setLoading(true);

      const res = await axiosInstance.get(
        `/Dashboard/get_financial_year_dropdown_sep_to_aug`
      );

      // res.data => { response, years }
      const { response, years } = res.data || {};

      if (response?.statusCode === 200) {
        const list = (years || []).map((x) => x?.financialYear).filter(Boolean);

        setFinancialYearList(list);

        // optional: auto select latest FY
        if (list.length > 0) setSelectedFinancialYear(list[list.length - 1]);
      } else {
        setFinancialYearList([]);
        setSelectedFinancialYear("");
      }
    } catch (error) {
      console.log("Error fetching FY dropdown:", error);
      setFinancialYearList([]);
      setSelectedFinancialYear("");
    } finally {
      setLoading(false);
    }
  };

  const navigate = useNavigate();

  useEffect(() => {
    // handleGetAcceptedRegistrationRequest();
    // handleGetNewVerifiedAdvocateDetails();
    handleGetSoldVoucherDetailsByBarAssociationId();
    handleGetMissingVoucherDetailsByBarAssociationId();
    handleGetActiveMembersVoucherDetailsByBarAssociationId();
    handleGetInactiveMemberFromTwoMonths();
    // handleGetPendingRegistrationRequest();
    handleGetDashboardTableDetailsCount();

    // ✅ ONLY ADDED
    handleGetFinancialYearDropdown();

    // console.log('total counts of table data', totalCountOfTablesData);
  }, []);

  useEffect(() => {
    console.log("total counts of table data", totalCountOfTablesData);
  }, [totalCountOfTablesData]);

  console.log(
    "Reduced voucher amount for current month",
    currentMonth,
    "and year",
    ":",
    filterAndReduceVoucherAmountMonthly(soldVoucherDetailsList, currentMonth)
  );
  console.log(
    "Reduced voucher amount for current year",
    ":",
    filterAndReduceVoucherAmountYearly(soldVoucherDetailsList, currentYear)
  );

  const openPdfFromResponse = (data) => {
    // Create a Blob from the response data
    const file = new Blob([data], { type: "application/pdf" });

    // Create a temporary URL for the Blob
    const fileURL = URL.createObjectURL(file);

    // Open the PDF in a new tab
    window.open(fileURL, "_blank");
  };

  const handleTentativeVotingList = async () => {
    try {
      setLoading(true);
      // Note: Endpoint path matches the Controller Route + Method Route
      // Route("api/[controller]") -> /api/Dashboard/TentativeVotingList
      const response = await axiosInstance.get(
        `/Dashboard/TentativeVotingList`,
        { responseType: "blob" } // CRITICAL: Tells axios to handle response as a file
      );

      openPdfFromResponse(response.data);
    } catch (error) {
      console.error("Error fetching Tentative List:", error);
      alert(
        "Could not open the voting list. Please ensure the file exists on the server."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleDefaulterList = async () => {
    try {
      setLoading(true);

      const financialYear = selectedFinancialYear; // from dropdown

      if (!financialYear) {
        alert("Please select Financial Year.");
        return;
      }

      // 1) Fetch JSON from API
      const response = await axiosInstance.get(`/Dashboard/DefaulterList`, {
        params: { financialYear },
      });

      const { response: apiRes, defaulters } = response.data || {};

      if (apiRes?.statusCode !== 200) {
        alert(apiRes?.status || "Failed to fetch defaulter list.");
        return;
      }

      const rows = defaulters || [];

      // 2) Generate PDF
      const doc = new jsPDF("l", "pt", "a4"); // landscape
      doc.setFontSize(14);
      doc.text(`Defaulter List (FY: ${financialYear})`, 40, 40);

      autoTable(doc, {
        startY: 60,
        head: [
          [
            "#",
            "Advocate Bar ID",
            "Name",
            "Voucher Count",
            "Mobile",
            "Email",
            "Address",
            "Status",
          ],
        ],
        body: rows.map((x, idx) => [
          idx + 1,
          x?.advocateBarId || "",
          x?.name || "",
          x?.voucherCount ?? 0,
          x?.mobileNo || "",
          x?.email || "",
          x?.permanentAddress || "",
          x?.status || "",
        ]),
        styles: { fontSize: 8, cellPadding: 3 },
        headStyles: { fontSize: 9 },
        columnStyles: {
          0: { cellWidth: 30 },
          1: { cellWidth: 90 },
          2: { cellWidth: 120 },
          3: { cellWidth: 70 },
          4: { cellWidth: 80 },
          5: { cellWidth: 140 },
          6: { cellWidth: 180 },
          7: { cellWidth: 70 },
        },
      });

      // 3) Open PDF in new tab
      const blob = doc.output("blob");
      const url = URL.createObjectURL(blob);
      window.open(url, "_blank");
    } catch (error) {
      console.error("Error fetching Defaulter List:", error);
      alert("Could not open the defaulter list PDF. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {" "}
      {loading && <Loader />}
      <div className="pb-4">
        <MDBContainer fluid>
          <MDBRow className="my-3">
            <MDBCol md="8" className="d-flex align-items-center">
              <img
                src={Dashboardicon}
                alt="Dashboard Icon"
                className="me-2"
                style={{ width: "42px" }}
              />
              <h4 className="m-0" style={{ fontWeight: "bold" }}>
                Dashboard
              </h4>
            </MDBCol>
            <MDBCol
              md="12"
              className="d-flex justify-content-end align-items-center"
            >
              <a href="/UserCreation">
                <MDBBtn color="primary" className="text-nowrap">
                  Create User
                </MDBBtn>
              </a>
              &nbsp;
              <a href="/FeesAndVoucherDetails">
                <MDBBtn color="success" className="text-nowrap">
                  Data Table
                </MDBBtn>
              </a>
              &nbsp;
              <a href="/GenrateVotingList">
                <MDBBtn color="warning" className="text-nowrap">
                  Genrate Voting list
                </MDBBtn>
              </a>
              &nbsp;
              <a href="/DeleteAdvocateDetails">
                <MDBBtn color="danger" className="text-nowrap">
                  Delete Advocate Details
                </MDBBtn>
              </a>
              &nbsp;
              <MDBBtn
                color="warning"
                className="text-nowrap"
                onClick={handleTentativeVotingList}
                disabled={loading} // Optional: Disable while fetching
              >
                Tentative Voting list
              </MDBBtn>
              {/* ✅ ONLY ADDED: FY dropdown just before Defaulter list button */}
              &nbsp;
              <select
                className="form-select form-select-sm"
                style={{ width: "140px", display: "inline-block" }}
                value={selectedFinancialYear}
                onChange={(e) => setSelectedFinancialYear(e.target.value)}
                disabled={loading || financialYearList.length === 0}
              >
                <option value="">Select FY</option>
                {financialYearList.map((fy) => (
                  <option key={fy} value={fy}>
                    {fy}
                  </option>
                ))}
              </select>
              &nbsp;
              <MDBBtn
                color="warning"
                className="text-nowrap"
                onClick={handleDefaulterList}
                disabled={loading || !selectedFinancialYear}
              >
                Defaulter list
              </MDBBtn>
            </MDBCol>
          </MDBRow>

          <MDBCard className="mb-2">
            <MDBCardBody>
              <MDBRow className="d-flex justify-content-between mb-1">
                <MDBCol className="flex-grow-1 mx-2 p-1">
                  <MDBCardTitle style={{ fontWeight: "bold" }}>
                    Members Analytics
                  </MDBCardTitle>
                  <MDBCardText className="text-small">
                    Data Shows As Per Member Activity
                  </MDBCardText>
                </MDBCol>
                <MDBCol className="flex-grow-1 mx-2 p-1">
                  <MDBRow className="align-items-center">
                    <MDBCol size="auto">
                      <img
                        src={totalregicon}
                        alt="Check Circle Icon"
                        className="me-2"
                        style={{ width: "48px" }}
                      />
                    </MDBCol>
                    <MDBCol>
                      <MDBCardText>
                        <h1>
                          {" "}
                          {totalCountOfTablesData[3]?.tableNoOfRowsCounts}
                        </h1>
                        <p className="text-small">Total Registered Members</p>
                      </MDBCardText>
                    </MDBCol>
                  </MDBRow>
                  <MDBBtn
                    color="link"
                    onClick={() =>
                      navigate(`/TotalRegMembers`, {
                        state: { RegistredMembers: acceptedMembershipDetails },
                      })
                    }
                    style={{ textDecoration: "none" }}
                    rippleColor="dark"
                  >
                    View all
                  </MDBBtn>
                </MDBCol>

                <MDBCol className="flex-grow-1 mx-2 p-1">
                  <MDBRow className="align-items-center">
                    <MDBCol size="auto">
                      <img
                        src={newreg}
                        alt="Check Circle Icon"
                        className="me-2"
                        style={{ width: "48px" }}
                      />
                    </MDBCol>
                    <MDBCol>
                      <MDBCardText>
                        <h1>
                          {totalCountOfTablesData[0]?.tableNoOfRowsCounts}
                        </h1>
                        <p className="text-small">New Registration Request</p>
                      </MDBCardText>
                    </MDBCol>
                  </MDBRow>
                  <MDBBtn
                    color="link"
                    onClick={() =>
                      navigate(`/NewRegReq`, {
                        state: {
                          NewRegistrationRequest: pendingMembershipDetails,
                        },
                      })
                    }
                    style={{ textDecoration: "none" }}
                    rippleColor="dark"
                  >
                    View all
                  </MDBBtn>
                </MDBCol>

                <MDBCol className="flex-grow-1 mx-2 p-1">
                  <MDBRow className="align-items-center">
                    <MDBCol size="auto">
                      <img
                        src={mostinactive}
                        alt="Check Circle Icon"
                        className="me-2"
                        style={{ width: "48px" }}
                      />
                    </MDBCol>
                    <MDBCol>
                      <MDBCardText>
                        <h1>{inactiveMembersDetailsList?.length}</h1>
                        <p className="text-small">Most Inactive Members</p>
                      </MDBCardText>
                    </MDBCol>
                  </MDBRow>
                  <MDBBtn
                    color="link"
                    onClick={() =>
                      navigate(`/Inactive`, {
                        state: {
                          InactiveMembersData: inactiveMembersDetailsList,
                        },
                      })
                    }
                    style={{ textDecoration: "none" }}
                    rippleColor="dark"
                  >
                    View all
                  </MDBBtn>
                </MDBCol>

                <MDBCol className="flex-grow-1 mx-2 p-1">
                  <MDBRow className="align-items-center">
                    <MDBCol size="auto">
                      <img
                        src={mostactiveicon}
                        alt="Check Circle Icon"
                        className="me-2"
                        style={{ width: "48px" }}
                      />
                    </MDBCol>
                    <MDBCol>
                      <MDBCardText>
                        <h1>
                          {findUniqueCountOfUttrakhandBarId(
                            activeMemberVoucherDetailsList
                          )}
                        </h1>
                        <p className="text-small">Most Active Members</p>
                      </MDBCardText>
                    </MDBCol>
                  </MDBRow>
                  <MDBBtn
                    color="link"
                    onClick={() =>
                      navigate(`/Active`, {
                        state: {
                          ActiveMembersData: activeMemberVoucherDetailsList,
                        },
                      })
                    }
                    style={{ textDecoration: "none" }}
                    rippleColor="dark"
                  >
                    View all
                  </MDBBtn>
                </MDBCol>
              </MDBRow>
            </MDBCardBody>
          </MDBCard>

          <MDBRow>
            <MDBCol lg="4">
              <MDBCol className="mb-4">
                <MDBCard className="">
                  <MDBCardBody className="d-flex flex-column">
                    <MDBRow className="d-flex justify-content-between mb-3">
                      <MDBCol
                        md="8"
                        className="d-flex flex-column align-items-start"
                      >
                        <MDBCardTitle style={{ fontWeight: "bold" }}>
                          Registration Analytics
                        </MDBCardTitle>
                        <MDBCardText className="text-small">
                          Data Shows Total Registration and New Request
                        </MDBCardText>
                      </MDBCol>
                      <MDBCol
                        md="4"
                        className="d-flex flex-column align-items-end"
                      >
                        {/* <DatePicker
                        selected={selectedDate}
                        onChange={(date) => setSelectedDate(date)}
                        placeholderText="Select Date"
                        className="form-control"
                      /> */}
                      </MDBCol>
                    </MDBRow>
                    <MDBRow className="d-flex justify-content-between mt-4">
                      <MDBCol
                        md="6"
                        className="d-flex flex-column align-items-start"
                      >
                        <MDBCardText>
                          <h2>
                            {" "}
                            {totalCountOfTablesData[3]?.tableNoOfRowsCounts}
                          </h2>
                          <p className="text-small">Total Registration</p>
                        </MDBCardText>
                      </MDBCol>
                      <MDBCol
                        md="6"
                        className="d-flex flex-column align-items-end"
                      >
                        <MDBCardText>
                          <h2>
                            {" "}
                            {totalCountOfTablesData[1]?.tableNoOfRowsCounts}
                          </h2>
                          <p
                            onClick={() => navigate(`/RejectedRequestDetails`)}
                            style={{
                              textDecoration: "none",
                              cursor: "pointer",
                            }}
                            rippleColor="dark"
                            className="text-small"
                          >
                            Rejected Registration Request
                          </p>
                        </MDBCardText>
                      </MDBCol>
                    </MDBRow>
                  </MDBCardBody>
                </MDBCard>
              </MDBCol>

              <MDBCol className="mb-4">
                <MDBCard className="h-100">
                  <MDBCardBody className="d-flex flex-column">
                    <MDBRow className="d-flex justify-between mb-3">
                      <MDBCol
                        md="10"
                        className="d-flex flex-column align-items-start"
                      >
                        <MDBCardTitle style={{ fontWeight: "bold" }}>
                          Verification Analytics
                        </MDBCardTitle>
                        <MDBCardText className="text-small">
                          Data Shows Total Verification and New Verification
                        </MDBCardText>
                      </MDBCol>
                    </MDBRow>
                    <MDBRow className="d-flex justify-content-between mt-4">
                      <MDBCol
                        md="6"
                        className="d-flex flex-column align-items-start"
                      >
                        <MDBCardText>
                          <h2>
                            {" "}
                            {totalCountOfTablesData[3]?.tableNoOfRowsCounts}
                          </h2>
                          <p color="link" className="text-small">
                            Total Registered Members
                          </p>
                        </MDBCardText>
                      </MDBCol>
                      <MDBCol
                        md="6"
                        className="d-flex flex-column align-items-end"
                      >
                        <MDBCardText>
                          <h2>
                            {" "}
                            {totalCountOfTablesData[2]?.tableNoOfRowsCounts}
                          </h2>
                          <p
                            color="link"
                            onClick={() =>
                              navigate(`/LatestVerifiactionDetailsPage`)
                            }
                            style={{
                              textDecoration: "none",
                              cursor: "pointer",
                            }}
                            rippleColor="dark"
                          >
                            New Verification
                          </p>
                        </MDBCardText>
                      </MDBCol>
                    </MDBRow>
                  </MDBCardBody>
                </MDBCard>
              </MDBCol>
            </MDBCol>

            <MDBCol lg="4" className="mb-4">
              <MDBCard className="h-100">
                <MDBCardBody className="d-flex flex-column">
                  <MDBRow className="d-flex justify-content-between mb-3">
                    <MDBCol
                      md="6"
                      className="d-flex flex-column align-items-start"
                    >
                      <MDBCardTitle style={{ fontWeight: "bold" }}>
                        Total Revenue
                      </MDBCardTitle>
                      <MDBCardText className="text-small">
                        Total Revenue in all Sections per Month
                      </MDBCardText>
                    </MDBCol>
                    <MDBCol
                      md="6"
                      className="d-flex flex-column align-items-end"
                    >
                      <MDBCardText>
                        <h4>
                          ₹{" "}
                          {filterAndReduceVoucherAmountYearly(
                            soldVoucherDetailsList,
                            currentYear
                          )}
                        </h4>
                        <p className="text-small">Year {currentYear}</p>
                      </MDBCardText>
                    </MDBCol>
                  </MDBRow>
                  <MDBRow className="d-flex justify-content-center flex-grow-1">
                    <div style={{ width: "100%", height: "auto" }}>
                      {/* bar char details for the montly data show on label */}

                      <BarChart
                        MonthlySalesArray={MonthlySales}
                        SoldVoucherList={soldVoucherDetailsList}
                      />
                    </div>
                  </MDBRow>
                  <MDBRow className="d-flex">
                    <MDBCol
                      md="6"
                      className="d-flex flex-column align-items-start"
                    >
                      <MDBCardText>
                        <h4>
                          ₹{" "}
                          {filterAndReduceVoucherAmountMonthly(
                            soldVoucherDetailsList,
                            previousMonth,
                            currentYear
                          )}
                        </h4>
                        <p className="text-small">
                          Revenue Generated in Last Month
                        </p>
                      </MDBCardText>
                    </MDBCol>
                    <MDBCol
                      md="6"
                      className="d-flex flex-column align-items-end"
                    >
                      <MDBCardText>
                        <h4>
                          ₹{" "}
                          {filterAndReduceVoucherAmountMonthly(
                            soldVoucherDetailsList,
                            currentMonth,
                            currentYear
                          )}
                        </h4>
                        <p className="text-small">
                          Revenue Generated in Current Month
                        </p>
                      </MDBCardText>
                    </MDBCol>
                  </MDBRow>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>

            <MDBCol lg="4" className="mb-4">
              <MDBCard className="h-100">
                <MDBCardBody className="d-flex flex-column">
                  <MDBRow className="d-flex justify-content-between mb-3">
                    <MDBCol
                      md="8"
                      className="d-flex flex-column align-items-start"
                    >
                      <MDBCardTitle style={{ fontWeight: "bold" }}>
                        Missing Data Analytics
                      </MDBCardTitle>
                      <MDBCardText className="text-small">
                        Missing Coupon Data In All Sections
                      </MDBCardText>
                    </MDBCol>
                  </MDBRow>
                  <MDBRow className="d-flex justify-content-center flex-grow-1">
                    <MDBCol
                      md="12"
                      className="d-flex flex-column align-items-center mt-1"
                    >
                      {MonthlyMissingVoucherCounts.length > 0 && (
                        <PieChart voucherCounts={MonthlyMissingVoucherCounts} />
                      )}
                    </MDBCol>
                  </MDBRow>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>
          </MDBRow>

          <MisReporting />
        </MDBContainer>
      </div>
    </>
  );
};

export default Dashboard;
